import React from 'react'
import { Button, Col, Row } from 'react-bootstrap'
import { LinkContainer } from 'react-router-bootstrap'
import ForthcomingBox from '../components/ForthcomingBox'
import LandingImage from '../components/LandingImage'
import LevelDescription from '../components/LevelDescription'
import classes from './NewStartScreen.module.css'

const LevelDescriptionScreen = () => {
  return (
    <div className={classes.landingContainer}>
      <Row>
        <Col>
          <LevelDescription color={'blue'} />
        </Col>
      </Row>
    </div>
  )
}

export default LevelDescriptionScreen
